import actionTypes from "../actions/actionTypes";

const _initState = {
  isLoading: false,
  userManual: null,
  adminManual: null
};

const files = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_MANUAL_REQUEST:
      return { ...state, isLoading: true, userManual: null };

    case actionTypes.GET_USER_MANUAL_SUCCESS: {
      return { ...state, isLoading: false, userManual: action.res };
    }

    case actionTypes.GET_ADMIN_MANUAL_REQUEST:
      return { ...state, isLoading: true, adminManual: null };

    case actionTypes.GET_ADMIN_MANUAL_SUCCESS: {
      return { ...state, isLoading: false, adminManual: action.res };
    }

    case actionTypes.DOWNLOAD_FILE_REQUEST: {
      return { ...state, isLoading: true };
    }
    case actionTypes.DOWNLOAD_FILE_SUCCESS: {
      return { ...state, isLoading: false };
    }

    case actionTypes.DOWNLOAD_FILE_FAILURE:
    case actionTypes.GET_USER_MANUAL_FAILURE:
      return _initState;
    case actionTypes.GET_ADMIN_MANUAL_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default files;
